function isIceServer(value) {
    if (!value || typeof value !== 'object')
        return false;
    const urls = value.urls;
    if (typeof urls === 'string')
        return true;
    return Array.isArray(urls) && urls.every((entry) => typeof entry === 'string');
}
function normalizeIceServers(value) {
    if (typeof value === 'string') {
        return [{ urls: value }];
    }
    if (Array.isArray(value)) {
        if (value.length === 0)
            return null;
        if (value.every((entry) => typeof entry === 'string')) {
            return [{ urls: value }];
        }
        const servers = [];
        for (const entry of value) {
            if (typeof entry === 'string') {
                servers.push({ urls: entry });
                continue;
            }
            if (isIceServer(entry)) {
                const { urls, username, credential } = entry;
                servers.push({ urls, username, credential });
            }
        }
        return servers.length > 0 ? servers : null;
    }
    if (isIceServer(value)) {
        const { urls, username, credential } = value;
        return [{ urls, username, credential }];
    }
    return null;
}
/**
 * Parse ICE servers from a JSON string or comma-separated URL list.
 */
export function parseIceServers(raw) {
    if (!raw)
        return undefined;
    const trimmed = raw.trim();
    if (!trimmed)
        return undefined;
    const looksJson = trimmed.startsWith('{') || trimmed.startsWith('[');
    try {
        const parsed = JSON.parse(trimmed);
        const normalized = normalizeIceServers(parsed);
        if (normalized && normalized.length > 0) {
            return normalized;
        }
        if (looksJson) {
            return undefined;
        }
    }
    catch {
        if (looksJson) {
            return undefined;
        }
        // Fall back to comma-separated parsing below.
    }
    const urls = trimmed
        .split(',')
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0);
    if (urls.length === 0)
        return undefined;
    const urlValue = urls.length === 1 ? (urls[0] ?? '') : urls;
    return [{ urls: urlValue }];
}
//# sourceMappingURL=ice-config.js.map